import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import '../src/assets/css/bootstrap.min.css'
import '../src/assets/css/font-awesome.min.css'
import '../src/assets/css/magnific-popup.css'
import '../src/assets/css/default.css'
import '../src/assets/css/style.css'
import '../src/assets/css/custom.css'
import {store} from './store/index'
// 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

// 定义 channelToLabel 全局过滤器
Vue.filter('channelToLabel', function(channel) {
  // 处理 channel 为 null 或 undefined 的情况
  if (channel === null || channel === undefined) {
    return '';
  }
  // 将 channel 转换为字符串，确保能正确匹配 channelEnum 的键
  const channelStr = String(channel);
  const channelEnum = {
    "1": "市场洞察",
    "2": "消费趋势",
    "3": "进入韩国",
    "4": "市场验证案例",
    "5": "买家感言",
    "6": "展会与项目",
    "7": "市场报告",
    "8": "合作机构"
  };
  return channelEnum[channelStr] || channelStr;
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
